import React, { useEffect } from "react";
import { useScroll } from "ahooks";
import Iconfont from "@components/iconfont/iconfont";
import "./index.less";

/**
 * 滚动置顶按钮
 * 当 container 发生滚动(scrollTop > 0)时淡入显示;点击平滑回到顶部。
 *
 * container 可以是可滚动元素，也可以直接传 document 表示「整页滚动」
 * （官网资讯详情页就是这样：滚动的是文档，不是某个内部容器）。
 *
 * position 决定按钮贴在哪儿：
 * - "fixed"（默认）：贴视口右下角，不随页面滚动；
 * - "absolute"：贴父容器的右下角（父级需是定位元素），随该容器一起滚动。
 *   资讯详情页配合一个 0 高的 sticky 锚点使用，实现「容器到底前贴屏幕底、
 *   容器底部进入视口后贴容器底」的效果。
 *
 * 与 LangSwitch 联动：置顶按钮显隐变化时，向 window 派发 "lang-switch-scrolltop" 事件，
 * LangSwitch 监听该事件，在自身处于默认位置时让位（移动到距屏幕右边 100px），避免两按钮重叠。
 *
 * @param {Element|Document} container 滚动容器（传 document 表示整页滚动）
 * @param {number} x 距右边缘距离(px),默认 32
 * @param {number} y 距底部距离(px),默认 132
 * @param {"fixed"|"absolute"} position 定位方式，默认 fixed
 */
export default function ScrollTopBtn({ container, x = 32, y = 132, position = "fixed" }) {
  const scroll = useScroll(container);
  const visible = (scroll?.top || 0) > 0;

  // 显隐变化时通知 LangSwitch 让位
  useEffect(() => {
    window.dispatchEvent(new CustomEvent("lang-switch-scrolltop", { detail: { visible } }));
  }, [visible]);

  // 卸载时恢复 LangSwitch 位置
  useEffect(() => {
    return () => {
      window.dispatchEvent(new CustomEvent("lang-switch-scrolltop", { detail: { visible: false } }));
    };
  }, []);

  if (!container) return null;

  const handleClick = () => {
    /* document 没有 scrollTo：整页滚动时走 window（行为保持 smooth） */
    const scroller = container === document ? window : container;
    scroller.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className={`scroll-top-btn${
        position === "absolute" ? " scroll-top-btn--absolute" : ""
      }${visible ? " scroll-top-btn--visible" : ""}`}
      style={{ right: x, bottom: y }}
      onClick={handleClick}
    >
      <Iconfont type="icon-a-zhidingxi" />
    </div>
  );
}
